/* Lighting desk controls. Presets, defaults and oroApplyDesk() come from the inline script in theme.liquid. */
(function () {
  var root = document.querySelector('[data-oro-desk]');
  if (!root || !window.oroApplyDesk) return;

  var P = window.oroPresets, D = window.oroDeskDefaults;
  var LOW = { lasers: .3, haze: .5, pyro: 0, master: .55 };
  var toggle = root.querySelector('.oro-desk__toggle');
  var panel = root.querySelector('.oro-desk__panel');
  var faders = [].slice.call(root.querySelectorAll('input[data-ch]'));
  var presets = [].slice.call(root.querySelectorAll('[data-preset]'));
  var lowBtn = root.querySelector('[data-desk="low"]');
  var saveTimer;

  presets.forEach(function (b) {
    var p = P[b.getAttribute('data-preset')];
    [p.c, p.b, p.a].forEach(function (rgb, i) { b.querySelectorAll('.oro-desk__swatch i')[i].style.background = 'rgb(' + rgb + ')'; });
    b.querySelector('span:last-child').textContent = p.name;
  });

  function isLow(s) {
    return Object.keys(LOW).every(function (k) { return Math.abs(s[k] - LOW[k]) < .005; });
  }

  function render(s) {
    faders.forEach(function (f) {
      var ch = f.getAttribute('data-ch'), v = Math.round(s[ch] * 100);
      f.value = v;
      f.setAttribute('aria-valuetext', v + '%');
      root.querySelector('[data-val="' + ch + '"]').textContent = v;
    });
    presets.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-preset') === s.preset)); });
    lowBtn.setAttribute('aria-pressed', String(isLow(s)));
  }

  function set(patch) {
    var s = Object.assign({}, window.oroDesk, patch);
    window.oroApplyDesk(s);
    render(s);
    document.dispatchEvent(new CustomEvent('oro:desk', { detail: s }));
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try { localStorage.setItem('oro-desk', JSON.stringify(s)); } catch (e) {}
    }, 150);
  }

  faders.forEach(function (f) {
    f.addEventListener('input', function () {
      var patch = {};
      patch[f.getAttribute('data-ch')] = Number(f.value) / 100;
      set(patch);
    });
  });
  presets.forEach(function (b) {
    b.addEventListener('click', function () { set({ preset: b.getAttribute('data-preset') }); });
  });
  lowBtn.addEventListener('click', function () { set(isLow(window.oroDesk) ? { lasers: 1, haze: 1, pyro: 1, master: 1 } : LOW); });
  root.querySelector('[data-desk="reset"]').addEventListener('click', function () { set(Object.assign({}, D)); });

  /* the "Click me!" sticker retires once the desk has been opened */
  try { if (localStorage.getItem('oro-desk-seen')) root.classList.add('is-seen'); } catch (e) {}

  function open(on) {
    panel.hidden = !on;
    toggle.setAttribute('aria-expanded', String(on));
    if (on) {
      panel.querySelector('input').focus({ preventScroll: true });
      root.classList.add('is-seen');
      try { localStorage.setItem('oro-desk-seen', '1'); } catch (e) {}
    }
  }
  toggle.addEventListener('click', function () { open(panel.hidden); });
  root.querySelector('[data-desk="close"]').addEventListener('click', function () { open(false); toggle.focus(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { open(false); toggle.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (!panel.hidden && !root.contains(e.target)) open(false);
  });

  render(window.oroDesk);
})();
